import { withInstall } from '../utils'
import _Swipe from './Swipe'
import './index.scss'

export const Swipe = withInstall(_Swipe)
export default Swipe
